import Swal from 'sweetalert2';

/**
 * Put a meeting's link on the clipboard. Where the browser will not allow that
 * (an http page, a locked-down webview) the link is shown, ready to copy by hand.
 * Returns whether it was copied.
 */
export const copyLink = async (link) => {
    if (!link) return false;
    try {
        await navigator.clipboard.writeText(link);
        return true;
    } catch {
        Swal.fire({ title: 'Meeting link', text: link, icon: 'info' });
        return false;
    }
};

/** The link to share, from a meeting the server sent (or its room code as a last resort). */
export const shareLinkOf = (meeting) => {
    if (!meeting) return '';
    if (meeting.joinLink) return meeting.joinLink;
    return meeting.roomCode ? `${window.location.origin}/meet/${meeting.roomCode}` : '';
};
